<!-- Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. -->
<ng-container *ngIf="!(collapsed$ | async)">
	<ng-content></ng-content>
</ng-container>
